import { useMemo } from 'react';
import map from 'lodash/map';
import { filter } from 'lodash';

import companyPhoneNumbersResource from 'src/actions/companyPhoneNumber/companyPhoneNumbersResource';
import endpointsResource, { Endpoint } from 'src/actions/endpoints/endpointsResource';
import { EndpointTypes } from 'src/models/Channels/endpointType';
import { PhoneNumberCapability } from 'src/models/CompanyPhoneNumber/CompanyPhoneNumber';
import useResource, { getConsolidatedState, isLoadingStatus } from 'src/presentation/hooks/useResource';

export default function useAvailableNumbersForWhatsApp() {
  const { values: endpoints = [], loadingState: endpointsLoadingState } = useResource(endpointsResource);
  const { values: companyNumbers = [], loadingState: companyNumbersLoadingState } =
    useResource(companyPhoneNumbersResource);

  const existingWhatsAppEndpoints = useMemo(
    () =>
      endpoints
        .filter((endpoint: Endpoint) => endpoint.type === EndpointTypes.WHATSAPP)
        .reduce((acc, endpoint: Endpoint) => {
          acc[endpoint.address] = endpoint;
          return acc;
        }, {}),
    [endpoints]
  );

  const availableNumbers = useMemo(
    () =>
      companyNumbers.filter(
        ({ capabilities, phoneNumber, status }) =>
          capabilities.includes(PhoneNumberCapability.SMS) &&
          !existingWhatsAppEndpoints[phoneNumber] &&
          status === 'ACTIVE'
      ),
    [companyNumbers, existingWhatsAppEndpoints]
  );

  const usedNumbers = useMemo(
    () =>
      map(
        filter(endpoints, endpoint => endpoint.type === 'WHATSAPP'),
        endpoint => endpoint.address
      ),
    [endpoints]
  );

  const loadingStates = [companyNumbersLoadingState, endpointsLoadingState];
  const loadingState = getConsolidatedState(loadingStates);

  return {
    isLoading: isLoadingStatus(loadingState),
    availableNumbers,
    usedNumbers,
  };
}
